



























































import { PropType } from 'vue';

import { IContract } from '@/models';

import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';
import snackbar from '@/mixins/snackbar';

import ContractAddAttachmentsFormDialog from './ContractAddAttachmentsFormDialog.vue';
import ContractAttachmentsListItem from './ContractAttachmentsListItem.vue';

const baseMixins = mixins(authMixin, snackbar);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    addAttachmentsFormDialog: InstanceType<
      typeof ContractAddAttachmentsFormDialog
    >;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'ContractAttachmentsList',

    components: {
      ContractAddAttachmentsFormDialog,
      ContractAttachmentsListItem
    },

    props: {
      contract: {
        type: Object as PropType<IContract>,
        required: true
      }
    },

    methods: {
      openCreateAttachmentDialog() {
        this.$refs.addAttachmentsFormDialog.open();
      }
    }
  });
